import { api } from "../shared/utilities/api";
import apiConfigs from "../shared/utilities/apiConfigs";

const JSON_HEADERS = { "Content-Type": "application/json" };

export const validateInviteToken = (token, orgId) =>
    api(apiConfigs.baseOption("POST", "inviteToken/validate", {
        headers: JSON_HEADERS,
        data: { token, orgId },
    }));

export const createPatient = (payload) =>
    api(apiConfigs.baseOption("POST", "register/createPatient", {
        headers: JSON_HEADERS,
        data: payload,
    }));
